// extracted by mini-css-extract-plugin
export default {"add__review":"AddReview_add__review__Pk36Y","inputs":"AddReview_inputs__ipTxn","review__label":"AddReview_review__label__kPBha"};